import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeBox16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCodeBox16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 3h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm7.88 1.612a.5.5 0 0 1 .288.646L7.693 10.1a.5.5 0 1 1-.933-.358L8.235 5.9a.5.5 0 0 1 .645-.288m-2.95.851a.5.5 0 1 0-.707-.707L3.32 7.66l-.354.353.354.354 1.903 1.903a.5.5 0 0 0 .707-.707l-1.55-1.55zm4.14 0a.5.5 0 1 1 .707-.707L12.68 7.66l.354.353-.354.354-1.903 1.903a.5.5 0 0 1-.707-.707l1.55-1.55z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeBox16);
